import gql from 'graphql-tag';
import { editorBlockFragment } from '@getaccept/editor-lib';
import { DocumentFragments } from './document.fragments';

export class DocumentMutations {
  static download = gql`
    mutation download($documentId: String!) {
      download(documentId: $documentId)
    }
  `;

  static publishDocumentMutation = gql`
    mutation publishDocument($documentId: String!, $message: String!) {
      publishDocument(documentId: $documentId, message: $message)
    }
  `;

  static discardChangesMutation = gql`
    mutation discardChanges($documentId: String!) {
      discardChanges(documentId: $documentId)
    }
  `;

  static createPage = gql`
    mutation CreatePage(
      $documentId: String!
      $pageNum: Int!
      $videoId: String
      $blockId: String
      $pageType: DocumentPageType
      $defaultEditorRows: [CreateRowInput!]
      $fontSettings: InputFontSettings
    ) {
      addDocumentPage(
        documentPageInput: {
          documentId: $documentId
          pageNum: $pageNum
          videoId: $videoId
          blockId: $blockId
          pageType: $pageType
          defaultEditorRows: $defaultEditorRows
          fontSettings: $fontSettings
        }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        video {
          id
          videoUrl
          thumbUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
    }
    ${editorBlockFragment}
  `;

  static deleteDocumentPageMutation = gql`
    mutation DeleteDocumentPage(
      $documentId: String!
      $documentPageId: String!
      $deletedPricingTableIds: [String!]
    ) {
      deleteDocumentPage(
        documentId: $documentId
        documentPageId: $documentPageId
        deletedPricingTableIds: $deletedPricingTableIds
      )
    }
  `;

  static implementTemplateInDocumentMutation = gql`
    mutation ImplementTemplateInDocument(
      $documentId: String!
      $templateId: String!
      $pageOffset: Int!
    ) {
      implementTemplateInDocument(
        documentId: $documentId
        templateId: $templateId
        pageOffset: $pageOffset
      ) {
        ...documentFragment
      }
    }
    ${DocumentFragments.documentFragment}
  `;

  static sortDocumentPagesMutation = gql`
    mutation SortDocumentPages(
      $documentId: String!
      $documentPageIds: [String!]!
      $pageNums: [Int!]!
    ) {
      sortDocumentPages(
        payload: { documentId: $documentId, documentPageIds: $documentPageIds, pageNums: $pageNums }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
      }
    }
  `;

  static sealDocumentMutation = gql`
    mutation SealDocument($documentId: String!, $sendDocument: Boolean!) {
      sealDocument(documentId: $documentId, sendDocument: $sendDocument)
    }
  `;

  static updateSignatureMutation = gql`
    mutation UpdateSignature($signature: String!) {
      updateSignature(signature: $signature)
    }
  `;

  static deleteDocumentsMutation = gql`
    mutation DeleteDocuments($ids: [String!]!) {
      deleteDocuments(ids: $ids)
    }
  `;

  static updateDocumentPageMutation = gql`
    mutation UpdateDocumentPage(
      $id: String!
      $pageType: DocumentPageType
      $videoId: String
      $blockId: String
    ) {
      updateDocumentPage(
        documentPage: { id: $id, videoId: $videoId, blockId: $blockId, pageType: $pageType }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
          videoTitle
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
    }
    ${editorBlockFragment}
  `;

  static documentUpdatedMutation = gql`
    mutation DocumentUpdated($documentId: String!) {
      documentUpdated(documentId: $documentId)
    }
  `;

  static updateDocumentMutation = gql`
    mutation UpdateDocument(
      $documentId: String!
      $settings: UpdateDocumentSettings = { transferMode: transfer }
      $patch: UpdateDocumentPatch!
    ) {
      updateDocumentV2(documentId: $documentId, settings: $settings, patch: $patch)
    }
  `;

  static updateAndLogSelfSignSignatureMutation = gql`
    mutation UpdateAndLogSelfSignSignature(
      $documentId: String!
      $signature: String!
      $signatureBase64Svg: String
      $replaceUserSignature: Boolean
      $nodeIds: [String!]
    ) {
      updateAndLogSelfSignSignature(
        documentId: $documentId
        signature: $signature
        signatureBase64Svg: $signatureBase64Svg
        replaceUserSignature: $replaceUserSignature
        nodeIds: $nodeIds
      )
    }
  `;

  static updateDocuments = gql`
    mutation updateDocumentsV2(
      $documentIds: [String!]!
      $settings: UpdateDocumentSettings = { transferMode: transfer }
      $patch: UpdateDocumentPatch!
    ) {
      updateDocumentsV2(documentIds: $documentIds, settings: $settings, patch: $patch)
    }
  `;

  static downloadDocuments = gql`
    mutation DownloadDocuments($documentIds: [String!]!) {
      batchDownloadDocuments(documentIds: $documentIds)
    }
  `;

  static triggerEditAfterSentEvent = gql`
    mutation TriggerEditAfterSentEvent($isActive: Boolean!, $documentId: String!) {
      triggerEditAfterSendEvent(isActive: $isActive, documentId: $documentId)
    }
  `;

  static updateDocumentQualifiedElectronicSignature = gql`
    mutation UpdateDocumentQualifiedElectronicSignature(
      $documentId: String!
      $payload: UpdateDocumentPayload!
    ) {
      updateDocument(documentId: $documentId, payload: $payload)
    }
  `;
}
